import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import {Search} from 'lucide-react';
import classes from "./PurchaseInvoices.module.css"
import plus from "../../../Assets/plus.svg"
import EyeIcon from "../../../Assets/new-eye.svg"
import DeleteIcon from "../../../Assets/new-delete.svg"
import PencilIcon from "../../../Assets/pencil.svg"
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { Spinner, Badge, Button, Modal, Form, Row, Col, Container, Table } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import axios from 'axios';
import Swal from 'sweetalert2';
import HeaderNav from "../../Accoungting/HeaderNav/HeaderNav";
import RotatingLogo from '../../../Assets/rotating-logo.png';
import { FaTrash, FaPlus } from "react-icons/fa";  
import download from "../../../Assets/download1.svg"
import { MdAdd } from "react-icons/md";
import { FaPrint } from "react-icons/fa";
import { BASE_URL } from "../../../Components/Styles/API/API";
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";



const PurchaseInvoices = () => {
    const [selectedOption, setSelectedOption] = useState(null);
    const [searchTerm,setSearchTerm] = useState("");
    const [show, setShow] = useState(false);
    const [loanCode, setLoanCode] = useState("");
  const [loanDescription, setLoanDescription] = useState("");
  const [selectedReportTo, setSelectedReportTo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [show1, setShow1] = useState(false);
  const [showSup, setShowSup] = useState(false);
  const [uploadShow, setUploadShow] = useState(false);
  const [file, setFile] = useState(null);
  const [bearer, setBearer] = useState('');
  const [uploadLoading, setUploadLoading] = useState(false);
  const [bankName, setBankName] = useState('');
  const [bankName1, setBankName1] = useState('');
  const [accName, setAccName] = useState('');
  const [accName1, setAccName1] = useState('');
  const [accNo, setAccNo] = useState('');
  const [accNo1, setAccNo1] = useState('');
  const [fullName, setFullName] = useState("");
  const [fullName1, setFullName1] = useState("");
  const [email, setEmail] = useState("");
  const [email1, setEmail1] = useState("");
  const [address, setAddress] = useState([]);
  const [address1, setAddress1] = useState([]);
  const [phone, setPhone] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [sICode, setSICode] = useState("");
  const [description, setDescription] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedPayables, setSelectedPayables] = useState(null);
  const [accPay, setAccPay] = useState([]);
  const [selectedImage, setSelectedImage] = useState('');
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const [user, setUser] = useState('');
  const [provinceID, setProvinceID] = useState('');
  const navigate = useNavigate();
  const [statLoading, setStatLoading] = useState(false);
  const [stat, setStat] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [roleLoading, setRoleLoading] = useState(false);
  const [roleLoading1, setRoleLoading1] = useState(false);
  const [searchedResult, setSearchedResult] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [entriesPerPage, setEntriesPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [glMethod, setGlMethod] = useState([]);
  const [selectInvoice, setSelectInvoice] =useState(null);
  const [customerList, setCustomerList] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState();

  const [generalInvoices, setGeneralInvoices] = useState([]);
  const [totalDiscount, setTotalDiscount] = useState('');
  const [totalTax, setTotalTax] = useState('');
  const [totalAmount, setTotalAmount] = useState('');
  const [itemList, setItemList] = useState([]);
  const [taxes, setTaxes] = useState([]);
  const [selectOptions1, setSelectOptions1] = useState([]);
  const [selectedSource, setSelectedSource] = useState('');
  const [selectedMode, setSelectedMode] = useState('');
  const [mod, setMod] = useState([]);
  const [debitCode, setDebitCode] = useState('');
  const [debitAmount, setDebitAmount] = useState('');
  const [salesRep, setSalesRep] = useState([]);
  const [createLoading, setCreateLoading] = useState(false);
  const [supplierName, setSupplierName] = useState("");
  const [supllierAddress, setSupplierAddress] = useState("");
  const [supplierPhone, setSupplierPhone] = useState("");
  const [supAccName, setSupAccName] = useState("");
  const [supAccNo, setSupAccNo] = useState("");
  const [supplierEmail, setSupplierEmail] = useState("");
  const [supplierBank, setSupplierBank] = useState("");
  const [officeAddress, setOfficeAddress] = useState("");

  const initialState = (selectInvoice) => {
    if (selectInvoice?.items && selectInvoice.items.length > 0) {
      return selectInvoice.items.map(item => ({
        items: { value: item?.item?.id || '', label: item?.item?.name || '' },
        unitPrice: item?.item?.price || '',
        qty: item?.quantity || '',
        vat: {
          value: item?.tax?.id || '',
          label: item?.tax ? `${item.tax.short_name} - ${item.tax.rate}` : '',
          rate: item?.tax?.rate || 0,
        },
        discountPercentage: item?.discount_percentage || '',
        discount: item?.discount || '',
        amount: item?.amount || '',
      }));
    }
    return [{
      items: '',
      unitPrice: '',
      qty: '',
      vat: '',
      discountPercentage: '',
      discount: '',
      amount: '',
    }];
  };
  const [formData, setFormData] = useState(() => initialState(selectInvoice));
  
 

  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');
      const provinceId = await localStorage.getItem('provinceID');

      if (value !== null) {
        setBearer(value);
      }
      if (value1 !== null) {
        setUser(value1);
      }
      if (provinceId !== null) {
        setProvinceID(provinceId);
      }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };

  const fetchStat = async () => {
    setStatLoading(true);
    try {
        const response = await axios.get(`${BASE_URL}/total-purchase-invoice`, { headers });
        const stas = response.data?.data;
       
        setStat(stas);
     
    } catch (error) {
        if (error.response && error.response.status === 401) {
            navigate('/login');
        } else {
          let errorMessage = 'An error occurred. Please try again.';
          if (error.response && error.response.data && error.response.data.message) {
              if (typeof error.response.data.message === 'string') {
                  errorMessage = error.response.data.message;
              } else if (Array.isArray(error.response.data.message)) {
                  errorMessage = error.response.data.message.join('; ');
              } else if (typeof error.response.data.message === 'object') {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: errorMessage,
                });
                console.log(errorMessage);
              }
          }
          setStat([]);
        }
    } finally {
        setStatLoading(false);
    }
  };
  
  const fetchData = async () => {
    setRoleLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/fetch-purchases-invoice`, { headers });
      const results = response.data?.data;
      setTableData(results);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      } else {
        const errorStatus = error.response?.data?.message;
        console.log(errorStatus);
        setTableData([]);
      }
    } finally {
      setRoleLoading(false);
    }
  };
  
    useEffect(() => {
      if (bearer) {
        fetchStat();
        fetchData();
      }
    }, [bearer]);

    const fetchSearch = async (searchTerm) => {
      setSearchLoading(true);
      try {
        let res;
        if (searchTerm.trim() === "") {
          res = tableData;
        } else {
          const response = await axios.get(`${BASE_URL}/customer/search`, {
            params: { variable: searchTerm },
            headers
          });
          res = response.data?.data;
        }
        setSearchedResult(res);
        console.log(res, "searched");
  
      } catch (error) {
        if (error.response && error.response.status === 401) {
          navigate('/login');
        } else {
          let errorMessage = 'An error occurred. Please try again.';
          if (error.response && error.response.data && error.response.data.message) {
            if (typeof error.response.data.message === 'string') {
              errorMessage = error.response.data.message;
            } else if (Array.isArray(error.response.data.message)) {
              errorMessage = error.response.data.message.join('; ');
            } else if (typeof error.response.data.message === 'object') {
              errorMessage = JSON.stringify(error.response.data.message);
            }
          }
          setSearchedResult([]);
        }
      } finally {
        setSearchLoading(false);
      }
    };
  
    useEffect(() => {
      const handler = setTimeout(() => {
        if (searchTerm.trim() !== "") {
          fetchSearch(searchTerm);
        } else {
          setSearchedResult([]); // clear results if empty
        }
      }, 500); // 500ms debounce
  
      return () => {
        clearTimeout(handler); // cancel on new keystroke
      };
    },[searchTerm]);

    const isSearching = searchTerm.trim() !== "" && searchedResult.length > 0;

    const fetchInvoiceCode = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${BASE_URL}/generate-sales-invoice-code`,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${bearer}`
            }
          }
        );
        const resultss = response.data?.data;
        //   console.log(resultss);
        setSICode(resultss);
        // console.log(invoiceData)
        //   console.log(results, "NI");
      } catch (error) {
        const errorStatus = error.response.data.message;
        console.error(errorStatus);
      } finally {
        setLoading(false);
      }
    };
  
    useEffect(() => {
      if (bearer) {
        fetchInvoiceCode();
      }
    }, [bearer]);

  const handleClose1 = () => setShow1(false);


const handleShow1 = (item) => {
  setSelectInvoice(item);
  setGeneralInvoices(item?.items || []);
  setSelectedCustomer(item?.supplier?.id || null);
  setDescription(item?.description || '');
  setShow1(true);
};


const handleShow = () => setShow(true);
const handleClose = () => setShow(false);
const handleShowSup = () => setShowSup(true);
const handleCloseSup = () => setShowSup(false);


const createSupplier = async () => {
  setLoading(true);
  try {
    const response = await axios.post(`${BASE_URL}/beneficiary/add`,
      {
        name: fullName,
        email: email,
        phone_number: phone,
        address: address,
        bank_name: bankName,
        account_name: accName,
        account_number: accNo
      },
      { headers }
    );
    console.log(response.data.message)
    const newCustomer = {
      label: response.data.data.name,
      value: response.data.data.id 
    };

    console.log(newCustomer);

    setCustomerList([...customerList, newCustomer]);
    setSelectedCustomer(newCustomer.value);

    fetchCustomers();
    setFullName('');
    setEmail('');
    setPhone('');
    setAddress('');
    setBankName('');
    setAccName('');
    setAccNo('');
  
    handleClose();
    // return
    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: response.data.message,
    });
    console.log(response.data);

  } catch (error) {
    const errorStatus = error.response.data.message;
    Swal.fire({
      icon: 'error',
      title: 'Failed',
      text: JSON.stringify(error.response.data.message),
    });
    // toast.error(JSON.stringify(error.response.data.message));
    console.log(error);
  } finally {
    setLoading(false);
  }
};

    // const handleChange = (option) => {
    //         setSelectedOption(option);
    //         console.log("Selected:", option);
    //     };
    function getLoanColors(name) {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = Math.abs(hash) % 360;

  return {
    backgroundColor: `hsl(${hue}, 70%, 90%)`, 
    color: `hsl(${hue}, 70%, 30%)`,   
  };
}

  const [rows, setRows] = useState([{ items: "", price: "", qty: "", disperc: "", discount: "", vat: "" }]);
  // const addRow = () =>
  //   setRows([...rows, { items: "", price: "", qty: "", disperc: "", discount: "", vat: "" }]);

  // const deleteRow = (index) => {
  //   const updatedRows = rows.filter((_, i) => i !== index);
  //   setRows(updatedRows);
  // };
  const addRow = () => {
    const newRow = {
      items: '', unitPrice: '', qty: '', vat: '', discountPercentage: '', discount: '', totalPrice: ''
    };
    setFormData([...formData, newRow]);
  };

  const deleteRow = (index) => {
    const updatedData = formData.filter((_, i) => i !== index);
    setFormData(updatedData);
  };

  

  const deleteRow2 = (index) => {
      const updatedGeneralInvoices = generalInvoices.filter((_, i) => i !== index);
      setGeneralInvoices(updatedGeneralInvoices);
    }

  const handleChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };

  const [rows1, setRows1] = useState([
    { account: "", accCode: "", description: "", amount: "", vat: "", total: "" },
  ]);

  const addRows = () =>
    setRows1([...rows1, { account: "", accCode: "", description: "", amount: "", vat: "", total: "" }]);


  const handleChange1 = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };
  const deleteRows = (index) => {
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
  };

const handleUploadShow = () => setUploadShow(true);
const handleUploadClose = () => {
  setUploadShow(false);
  setFile(null);
};

const handleFileChange = (event) => {
  const file = event.target.files[0];
  setFile(file);
};

// const uploadExcelHandler = async () => {
//   if (!file) {
//     Swal.fire({
//       icon: 'error',
//       title: 'Failed',
//       text: 'Please select a file to upload',
//     });
//     return;
//   }

//     // Confirmation alert before upload
//     const result = await Swal.fire({
//       title: "Are you sure?",
//       text: "Do you want to upload this file?",
//       icon: "question",
//       showCancelButton: true,
//       confirmButtonText: "Yes, upload it!",
//       cancelButtonText: "No, cancel",
//     });
  
//     if (!result.isConfirmed) {
//       handleUploadClose(); 
//       return; 
//     }

//   setUploadLoading(true);
//   try {
//     const formData = new FormData();
//     formData.append('file', file);

//     const response = await axios.post(
//       // `${BASE_URL}/beneficiary/upload`, 
//       formData, 
//       { headers: {
//           'Content-Type': 'multipart/form-data',
//           'Authorization': `Bearer ${bearer}`
//         } });

//     Swal.fire({
//       icon: 'success',
//       title: 'Success',
//       text: response.data.message || 'File uploaded successfully',
//     });
//     window.location.reload();

//     handleUploadClose();
//     setFile("");
//   } catch (error) {
//     let errorMessage;

//     if (error.response && error.response.data) {
//       errorMessage = typeof error.response.data.message === 'object'
//         ? JSON.stringify(error.response.data.message)
//         : error.response.data.message;
//     } else if (error.message) {
//       errorMessage = error.message;
//     } else {
//       errorMessage = 'An unexpected error occurred while uploading the file';
//     }

//     Swal.fire({
//       icon: 'error',
//       title: 'Failed',
//       text: errorMessage,
//     });
//     console.log(error);
//   } finally {
//     setUploadLoading(false);
//   }
// };

const uploadStatement = async () => {
  // setCreateLoading(true);
  setUploadLoading(true);

  try {

    const formData = new FormData();
    formData.append('file', selectedImage);
    formData.append('transaction_date', selectedDate);
    formData.append('description', description);
    formData.append('invoice_code', sICode);


    const response = await axios.post(
      `${BASE_URL}/upload-purchase-invoice-excel`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${bearer}`
        }
      }
    );
    handleUploadClose();
    // Reset form fields
    setSelectedImage("");
    Swal.fire({
      icon: 'success',
      title: 'Successful',
      text: response.data.message,
    });
  } catch (error) {
    let errorMessage = 'An error occurred. Please try again.';
    if (error.response && error.response.data && error.response.data.message) {
      if (typeof error.response.data.message === 'string') {
        errorMessage = error.response.data.message;
      } else if (Array.isArray(error.response.data.message)) {
        errorMessage = error.response.data.message.join('; ');
      } else if (typeof error.response.data.message === 'object') {
        errorMessage = JSON.stringify(error.response.data.message);
      }
      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: JSON.stringify(error.response.data.message),
      });
    }
    console.error(error);
  } finally {
    setUploadLoading(false);
  }
};

const createBeneficiary = async () => {
   // Confirmation alert before upload
   const result = await Swal.fire({
    title: "Are you sure?",
    text: "Are you sure you want to add new invoice",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Yes, create invoice!",
    cancelButtonText: "No, cancel",
  });

  if (!result.isConfirmed) {
    handleClose(); 
    return; 
  }

  setLoading1(true);
  try {
    const response = await axios.post(
      // `${BASE_URL}/beneficiary/add`,
      {
        name: fullName,
        email: email,
        phone_number: phone,
        address: address,
        bank_name: bankName,
        account_name: accName,
        account_number: accNo
      },
      // { headers }
    );
    console.log(response.data.message);
    setFullName('');
    setEmail('');
    setPhone('');
    setAddress('');
    setBankName('');
    setAccName('');
    setAccNo('');
    // fetchBeneficiaries();
    handleClose();
    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: response.data.message,
    });
    console.log(response.data.message);

  } catch (error) {
    let errorMessage;

    // Attempt to extract the error message
    if (error.response && error.response.data) {
      // If message is an object, attempt to stringify it
      if (typeof error.response.data.message === 'object') {
        errorMessage = JSON.stringify(error.response.data.message);
      } else {
        errorMessage = error.response.data.message;
      }
    } else if (error.message) {
      errorMessage = error.message;
    } else {
      errorMessage = "An unexpected error occurred";
    }

    Swal.fire({
      icon: 'error',
      title: 'Failed',
      text: errorMessage,
    });
    console.log(error);
  } finally {
    setLoading1(false);
  }
};

const handleTrashClick = async (id) => {
  const confirmed = await Swal.fire({
    title: 'Are you sure?',
    text: 'You are about to delete this invoice.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, cancel',
  });

  if (!confirmed.isConfirmed) {
    return; // User canceled, do nothing
  }
  setUploadLoading(true);

  try {
    const response = await axios.get(`${BASE_URL}/role/delete-role?role_id=${id}`, { headers });
      
    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: response.data.message,
    });
    fetchData();
  //  toast.success(response.data.message);
  //   setTrashClicked(true);
  setUploadLoading(false);
  } catch (error) {
    let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
            if (typeof error.response.data.message === 'string') {
                errorMessage = error.response.data.message;
            } else if (Array.isArray(error.response.data.message)) {
                errorMessage = error.response.data.message.join('; ');
            } else if (typeof error.response.data.message === 'object') {
                errorMessage = JSON.stringify(error.response.data.message);
            }
            // toast.error(errorMessage)
            console.log(errorMessage);
        }
  }
  finally {
    setUploadLoading(false); // always stop uploading, success or fail
  }
};

const handleDateChange = (event) => {
  setSelectedDate(event.target.value);
};

const handleImageChange = (event) => {
  const file = event.target.files[0];
  setSelectedImage(file);
};

const startIndexx = (currentPage - 1) * entriesPerPage + 1;
const filteredData = tableData.filter(item => item.supplier?.name.toLowerCase().includes(searchTerm.toLowerCase()));
const totalEntries = filteredData.length;
const endIndexx = Math.min(startIndexx + entriesPerPage - 1, totalEntries);
const displayedData = filteredData.slice(startIndexx - 1, endIndexx);
const totalPages = Math.ceil(filteredData.length / entriesPerPage);


const fetchCustomers = async () => {
  setLoading(true);
  try {
    const response = await axios.get(
      `${BASE_URL}/beneficiary`,
      {

        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${bearer}`
        }
      }
    );
    const custome = response.data?.data;
    const customs = custome.map(item => ({
      label: item.name,
      value: item.id
    }));
    setCustomerList(customs);
    // setAddress(custome);

    // console.log(custome, "itss");
  } catch (error) {
    const errorStatus = error.response.data.message;
    console.error(errorStatus);
  } finally {
    setLoading(false);
  }
};



const fetchAcPayables = async () => {
  setIsLoading(true);
  try {
    const response = await axios.get(`${BASE_URL}/account/payables`, { headers });
    const pay = response.data?.data;
    console.log("lists:", response);
    const payOptions = pay.map(item => ({
      label: item.gl_name,
      value: item.id
    }));

    setAccPay(payOptions);
  } catch (error) {
    if (error.response && error.response.status === 401) {
      // Redirect to login page if unauthorized
      navigate('/login');
    } else {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setAccPay([]);
    }
  } finally {
    setIsLoading(false);
  }
};

useEffect(() => {
  if (bearer) {
    fetchAcPayables();
    fetchCustomers();
  }
}, [bearer]);


const fetchItems = async () => {
  setIsLoading(true);
  try {
    const response = await axios.get(`${BASE_URL}/items/fetch-all`, { headers });
    const itemss = response.data?.data;

    const options1 = itemss.map((item) => ({
      label: item.name,
      value: item.id,
    }));
    setItemList(itemss);
    setSelectOptions1(options1);
  } catch (error) {
    const errorStatus = error.response?.data?.message;
    console.log(errorStatus);
    // setDebitAccounts([]);
  } finally {
    setIsLoading(false);
  }
};

const fetchTax = async () => {
  setIsLoading(true);
  try {
    const response = await axios.get(`${BASE_URL}/taxes/company-tax`, { headers });
    const itemss = response.data?.data;
    
    const seTax = itemss.map((item) => ({
      label: `${item.short_name} - ${item.rate}`,
      value: item.id,
      rate: item.rate
    }));
    setTaxes(seTax);
  } catch (error) {
    const errorStatus = error.response?.data?.message;
    console.log(errorStatus);
    setTaxes([]);
  } finally {
    setIsLoading(false);
  }
};

useEffect(() => {
  if (bearer) {
    fetchItems();
    fetchTax();
  }
}, [bearer]);

const extendedCustomerList = [
  { label: '(Add a new supplier)', value: 'add-new' },
  ...customerList
];
// const extendedCustomerList = [
//   { label: '(Add a new supplier)', value: 'add-new' },
//   ...customerList.map(c => ({
//     label: c.name,   // supplier display
//     value: c.name,   // used for matching
//   }))
// ];

const handleCustomerChange = (selectedOption) => {
  if (selectedOption.value === 'add-new') {
    handleShowSup();
    handleClose1();
  } else {
  setSelectedCustomer(selectedOption.value);
  }
};

const formattedTotalEntries = totalEntries.toLocaleString();

const handlePrevPage = () => {
  setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
};

const handleNextPage = () => {
  setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
};





useEffect(() => {
  const mergedData = [
    ...generalInvoices.map(item => ({
      amount: item.amount,
      discount: item.discount,
      unitPrice: item.item?.price,
      qty: item.quantity,
      vat: item.tax?.rate || 0,
    })),
    ...formData
  ];

  // Calculate the total amount
  const calculatedTotalAmount = mergedData.reduce(
    (acc, curr) => acc + (parseFloat(curr.amount) || 0),
    0
  );

  // Calculate the total discount
  const calculatedDiscount = mergedData.reduce(
    (acc, curr) => acc + (parseFloat(curr.discount) || 0),
    0
  );


  // Calculate the total VAT and total initial price
  const calculatedTotalVat = mergedData.reduce((acc, curr) => {
    const unitPrice = parseFloat(curr.unitPrice) || 0;
    const qty = parseFloat(curr.qty) || 0;
    // const discountPercentage = parseFloat(curr.discountPercentage?.replace('%', '') || 0);
    const discountAmount = parseFloat(curr.discount) || 0;
    
    const vatRate = curr.vat?.rate 
                  ? parseFloat(curr.vat.rate) || 0 
                  : parseFloat(curr.vat) || 0;

    // Calculate the initial price
    const initialPrice = (unitPrice * qty) - discountAmount;
    // Calculate VAT based on the initial price
    const vatAmount = initialPrice * (vatRate / 100);

    return acc + vatAmount;
  }, 0);



  // Set the total values
  setTotalAmount(calculatedTotalAmount.toFixed(2));
  setTotalDiscount(calculatedDiscount.toFixed(2));
  setTotalTax(calculatedTotalVat.toFixed(2));
  // setTotalPrice(calculatedInitialPrice.toFixed(2)); // Assuming you want to set this value
}, [generalInvoices, formData]);

const itemsExist = generalInvoices.length > 0;

const handleItemDescriptionChange = (selectedOption, rowIndex) => {
  const selectedItemId = selectedOption.value;
  const selectedItem = itemList.find(item => item.id === selectedItemId);
  const selectedUnitPrice = selectedItem?.price || 0;
  handleFormChange(selectedOption, "items", rowIndex);
  handleFormChange(selectedUnitPrice, "unitPrice", rowIndex);
};

const handleFormChange = (value, fieldName, rowIndex) => {
setFormData(prevFormData => {
  const updatedFormData = [...prevFormData];
  const currentRow = updatedFormData[rowIndex];
  
  // Update the field that triggered the change
  if (fieldName === 'vat') {
    // If vat is updated, store the whole tax item
    currentRow[fieldName] = value;
  } else {
    currentRow[fieldName] = value;
  }

  // Calculate total price based on qty and unitPrice
  const qty = parseFloat(currentRow.qty) || 0;
  const unitPrice = parseFloat(currentRow.unitPrice) || 0;
  let initialPrice = qty * unitPrice;

  // Calculate discount
  let discountAmount = 0;
  if (fieldName === 'discountPercentage' || fieldName === 'discount') {
    if (fieldName === 'discountPercentage') {
      const discountPercentage = parseFloat(value.replace('%', '')) || 0;
      discountAmount = (discountPercentage / 100) * initialPrice;
      currentRow.discount = discountAmount.toFixed(2);
    } else if (fieldName === 'discount') {
      discountAmount = parseFloat(value) || 0;
      const discountPercentage = (discountAmount / initialPrice) * 100;
      currentRow.discountPercentage = discountPercentage.toString();
    }
  } else {
    const discountPercentage = parseFloat(currentRow.discountPercentage.replace('%', '')) || 0;
    discountAmount = (discountPercentage / 100) * initialPrice;
    currentRow.discount = discountAmount.toFixed(2);
  }

  initialPrice -= discountAmount; // Apply discount to initial price
  

  // Calculate VAT and add to initial price
  const selectedTax = currentRow.vat;
  const vatRate = selectedTax ? parseFloat(selectedTax.rate) || 0 : 0;
  const vatAmount = (vatRate / 100) * initialPrice;
  const totalPrice = initialPrice + vatAmount;

  currentRow.amount = totalPrice.toFixed(2);

  return updatedFormData;
});
};

const fetchSource = async () => {
  setIsLoading(true);

  try {
    const response = await axios.get(`${BASE_URL}/pending-purchase-orders-id?id=${selectedMode}`, { headers });
    let genInv = response.data?.data[0]?.general_invoice;

    // Ensure genInv is an array
    if (!Array.isArray(genInv)) {
      genInv = genInv ? [genInv] : [];
    }

    console.log(response);

    // Update the state only if there is data
    if (genInv.length > 0) {
      setGeneralInvoices(genInv);
    } else {
      setGeneralInvoices([]);
    }

  } catch (error) {
    const errorStatus = error.response?.data?.message;
    console.log(error);
  } finally {
    setIsLoading(false);
  }
};

console.log(selectedSource, "rrr");

const fetchModes = async () => {
  setIsLoading(true);
  console.log(selectedSource, "jldkj");
  try {
    const response = await axios.get(`${BASE_URL}/pending-purchase-orders?mode=${selectedSource}`, 
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${bearer}`
        }
      }
    );

    console.log(response, "hehe");
    const itemss = response.data?.data;

    const modde = itemss.map((item) => ({
      label: `${item.uuid} - ${item.supplier?.name}`,
      value: item.id,
      customer: item.supplier?.name,
      customerId: item.supplier?.id,
      reference: item.reference ,
     
    }));
   
    setMod(modde);
    if (itemss.length === 0) {
      setSelectedMode(null);
    }


  } catch (error) {
    const errorStatus = error.response?.data?.message;
    console.log(error);
    setMod([]);
    setSelectedMode(null);
  } finally {
    setIsLoading(false);
  }
};

useEffect(() => {
  if (selectedMode !== null) {
    fetchSource();
  }
}, [selectedMode]);


useEffect(() => {
  if (selectedSource !== null) {
    fetchModes();
  }
}, [selectedSource]);

const isRowEmpty = (row) => {
  return (
    !row.items?.value &&
    !row.qty &&
    !row.amount &&
    !row.vat?.value &&
    !row.discount &&
    !row.discountPercentage
  );
};



const createSalesInvoice = async () => {
  setCreateLoading(true);

  try {

    const filteredFormData = formData.filter(row => !isRowEmpty(row));
    // Merge generalInvoices and formData
    const mergedData = [
      ...generalInvoices.map(item => ({
        itemId: item.item.id,
        quantity: item.quantity,
        amount: item.amount,
        tax: item.tax ? item.tax_id : null, 
        discount: item.discount,
        discountPercentage: item.discount_percentage
      })),
      ...filteredFormData.map(row => ({
        itemId: row.items.value || '',
        quantity: row.qty || '',
        amount: row.amount || '',
        tax: row.vat.value || '', 
        discount: row.discount || '',
        discountPercentage: row.discountPercentage?.replace('%', '') || ''
      }))
    ];

    // Extract data for the API request
    const items = mergedData.map(item => item.itemId);
    const quantities = mergedData.map(item => item.quantity);
    const amounts = mergedData.map(item => item.amount);
    const taxes = mergedData.map(item => item.tax); // Use tax id here
    const discounts = mergedData.map(item => item.discount);
    const discountPercents = mergedData.map(item => item.discountPercentage);

    // Log the arrays to ensure correct formatting
    console.log(selectedSource, selectedMode,discountPercents, discounts, description, items, quantities, amounts, taxes,  totalAmount, sICode, selectedCustomer, totalTax, totalDiscount);


    const response = await axios.post(
      `${BASE_URL}/post-purchase-invoice`,
      {
        order_id: selectedMode,
        // mode: selectedSource,
        item_id: items,
        quantity: quantities,
        item_amount: amounts,
        amount: totalAmount,
        description: description,
        invoice_number: sICode,
        supplier_id: selectedCustomer,
        tax_id: taxes,
        discount: discounts,
        discount_percentage: discountPercents,
        total_vat: totalTax,
        total_discount: totalDiscount
        
      },
      { headers }
    );

    console.log(response.data?.message, "heeee");
    setSICode("");
    setSelectedCustomer("");
    setDebitCode("");
    // setSelectedAccountName("");
    setDebitAmount("");
    setDescription("");
    setSelectedSource("");
    // handleSource({ value: "select" });
    setSelectedMode("");
    setFormData([]);
    setMod([]);
    fetchInvoiceCode();
    setGeneralInvoices([]);
    setSalesRep('');
    Swal.fire({
      icon: 'success',
      title: 'Successful',
      text: response.data.message,
    });

    // toast.success(response.data.message);
  } catch (error) {
    let errorMessage = 'An error occurred. Please try again.';
    if (error.response && error.response.data && error.response.data.message) {
      if (typeof error.response.data.message === 'string') {
        errorMessage = error.response.data.message;
      } else if (Array.isArray(error.response.data.message)) {
        errorMessage = error.response.data.message.join('; ');
      } else if (typeof error.response.data.message === 'object') {
        errorMessage = JSON.stringify(error.response.data.message);
      }
      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: JSON.stringify(error.response.data.message),
      });
      console.log(error);
    }
  } finally {
    setCreateLoading(false);
  }
};

       
  return (
    <div >
        <HeaderNav />

        <Modal show={showSup} onHide={handleCloseSup} animation={false}>
                    <Modal.Header closeButton>
                      <Modal.Title>Add Customer</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Form style={{ marginTop: 20 }}>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                          <Form.Label>Name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter Full Name"
                            // autoFocus
                            value={supplierName}
                            onChange={(e) => setSupplierName(e.target.value)}
                          />
                          <div style={{ marginTop: 10 }} />
                          <Form.Label>Address</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter Address"
                            // autoFocus
                            value={supllierAddress}
                            onChange={(e) => setSupplierAddress(e.target.value)}
                          />
                          <div style={{ marginTop: 10 }} />
                          <Form.Label>Office Address</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter office Address"
                            // autoFocus
                            value={officeAddress}
                            onChange={(e) => setOfficeAddress(e.target.value)}
                          />
                          <div style={{ marginTop: 10 }} />
                          <Form.Label>Phone Number</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter Phone Number"
                            // autoFocus
                            value={supplierPhone}
                            onChange={(e) => setSupplierPhone(e.target.value)}
                          />
                          <div style={{ marginTop: 10 }} />
                          <Form.Label>Email Address</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter Email Address"
                            // autoFocus
                            value={supplierEmail}
                            onChange={(e) => setSupplierEmail(e.target.value)}
                          />
                            <div style={{ marginTop: 10 }} />
                            <Form.Label>Bank Name</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter Supplier's Bank Name"
                              // autoFocus
                              value={supplierBank}
                              onChange={(e) => setSupplierBank(e.target.value)}
                            />
                            <div style={{ marginTop: 10 }} />
                            <Form.Label>Account Name</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter Supplier's Account Name"
                              // autoFocus
                              value={supAccName}
                              onChange={(e) => setSupAccName(e.target.value)}
                            />
                            <div style={{ marginTop: 10 }} />
                            <Form.Label>Account Number</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter Supplier's Account Number"
                              // autoFocus
                              value={supAccNo}
                              onChange={(e) => setSupAccNo(e.target.value)}
                            />
                        </Form.Group>
                      </Form>
                    </Modal.Body>

                    <Modal.Footer>
                      <Button variant="danger" onClick={handleCloseSup}>
                        Go back
                      </Button>
                      <Button variant="success" onClick={createSupplier}>
                        Create Supplier
                      </Button>
                    </Modal.Footer>
                  </Modal>
      
    
<Modal show={show1} onHide={handleClose1} size="xl" animation={false}>
  <Modal.Header closeButton>
    <Modal.Title>Edit Purchase Invoice</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
    {/* {selectInvoice ? ( */}
      <Form.Group className="mb-3">
      <Row>
        <Col 
        // md={6}
        >
        <Form.Label className={classes.formLabelCustom}>Invoice To</Form.Label>             
                <Select
                  placeholder='Select Supplier'
                  options={extendedCustomerList}
                  value={extendedCustomerList.find(opt => opt.value === selectedCustomer) || null}
                  onChange={handleCustomerChange}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    menu: (provided) => ({
                      ...provided,
                      maxHeight: '300px',
                      maxWidth: '700px',
                      overflowY: 'auto',
                    }),
                  }}
                />
        </Col>

        <Col 
        // md={6}
        >
        <Form.Label className={classes.formLabelCustom}>Invoice Code</Form.Label>
                      <Form.Control
                        className={classes.formControl}
                        type="text"
                        value={sICode}
                        disabled
           />
        </Col>

        <Col 
        // md={6}
        >
        <Form.Label >Description</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={1}
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        name="description"
                      />
        </Col>
      </Row>

      <Row className="mb-2 mt-4">
        {/* <Col md={6}>
        <Form.Label >Description</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={1}
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        name="description"
                      />
        </Col> */}
      </Row>
      </Form.Group>
   

      <Form.Group>
      <Container fluid style={{marginTop: "40px"}} className={classes.wrapper}>
      <h6 className={classes.headerText} style={{textAlign: "left"}}>Add Item(s)</h6>

      <div className="table-responsive">
      <table className={classes.customtable} style={{width: "100%"}}>
        <thead>
          <tr>
            <th>Item</th>
            <th>Unit Price</th>
            <th>Qty</th>
            <th style={{whiteSpace: "nowrap"}}>Discount (%)</th>
            <th>Discount</th>
            <th>V.A.T</th>
            <th>Total Price(N)</th>
            <th style={{backgroundColor: "unset"}} className="text-center">
              <button type="button" style={{backgroundColor: "unset"}} className={classes.plusbtn} onClick={addRow}>
              <FaPlus
              size={12}
              color="white"
              style={{ cursor: "pointer" }}
            />
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          {/* {rows.map((row, index) => (
            <tr key={index}>
              <td>
                <Form.Control
                  type="text"
                  value={row.items}
                  onChange={(e) =>
                    handleChange(index, "items", e.target.value)
                  }
                />
              </td>
              <td>
                <Form.Control
                  type="text"
                  value={row.price}
                  onChange={(e) =>
                    handleChange(index, "price", e.target.value)
                  }
                />
              </td>
              <td>
                <Form.Control
                  type="text"
                  value={row.qty}
                  onChange={(e) =>
                    handleChange(index, "qty", e.target.value)
                  }
                />
              </td>
              <td>
                <Form.Control
                  type="text"
                  value={row.disperc}
                  onChange={(e) =>
                    handleChange(index, "disperc", e.target.value)
                  }
                />
              </td>
              <td>
                <Form.Control
                  type="text"
                  value={row.discount}
                  onChange={(e) =>
                    handleChange(index, "discount", e.target.value)
                  }
                />
              </td>
              <td>
                <Form.Control
                  type="text"
                  value={row.vat}
                  onChange={(e) =>
                    handleChange(index, "vat", e.target.value)
                  }
                />
              </td>
              <td className="text-center">
                <button style={{backgroundColor: "unset"}} className={classes.btntrash} onClick={() => deleteRow(index)}>
                <img src={DeleteIcon}/>
                </button>
              </td>
            </tr>
          ))} */}

          {itemsExist ? (
            generalInvoices.map((item, index) => (
              <tr key={index}>
                <td style={{width: "150px" }}>
                  {item?.item?.name}
                </td>
                <td style={{textAlign: "right"}}>{parseFloat(item?.item?.price).toLocaleString('en-US', {
                                            minimumIntegerDigits: 1,
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                          })}</td>
                <td style={{ }}>
                {item?.quantity}
                </td>
                <td style={{textAlign: "right"}}>{item.discount_percentage}</td>
                <td style={{textAlign: "right"}}>{parseFloat(item?.discount).toLocaleString('en-US', {
                                          minimumIntegerDigits: 1,
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2
                                        })}</td>
                <td style={{ }}>
                {`${item?.tax?.short_name} - ${item.tax?.rate}`}
                </td>
               
                <td style={{textAlign: "right"}}>{parseFloat(item?.amount).toLocaleString('en-US', {
                                            minimumIntegerDigits: 1,
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                          })}</td>
                <td style={{ textAlign: "center" }}>
                <button style={{backgroundColor: "unset"}} className={classes.btntrash} onClick={() => deleteRow2(index)}>
                <img src={DeleteIcon}/>
                </button>
                {/* <div className="btn btn-danger-soft btn-sm" onClick={() => deleteRow2(index)}>
                <i className="far fa-trash-alt"  style={{color: "#dc3545", backgroundColor: "#dc35451a", padding: 2, borderColor: "#dc35454d", borderRadius: 5, fontSize: 12}}></i>
                </div> */}
                </td>
              </tr>
            ))
          ) : (
null
          )}
            {formData.map((row, index) => (
            <tr key={index}>
              <td style={{ }}>
                <div style={{width: "150px" }}>
                <Select
                  value={row.items}
                  onChange={(selectedOption) => handleItemDescriptionChange(selectedOption, index)}
                  options={selectOptions1}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    menu: (provided) => ({
                      ...provided,
                      maxHeight: '300px',
                      width: 'auto',
                      overflowY: 'auto',
                    }),
                  }}
                />
                </div>
              </td>
              <td style={{  }}>
                <CurrencyInput
                  name={`rowUnitPrice ${index}`}
                  decimalsLimit={2}
                  value={row.unitPrice}
                  className="form-control"
                  disabled
                  style={{ textAlign: "right", border: "none", width: '7rem' }}
                />
              </td>
              <td style={{ }}>
                <input
                  type="text"
                  className="form-control"
                  value={row.qty}
                  onChange={(e) => handleFormChange(e.target.value, "qty", index)}
                  // onBlur={calculateFormData}
                  style={{ width: '70px' }}
                />
              </td>
              <td style={{ width: '10px' }}>
              <input
  type="text"
  className="form-control"
  value={row.discountPercentage}
  onChange={(e) => handleFormChange(e.target.value, "discountPercentage", index)}
  onBlur={(e) => {
    const percentage = parseFloat(e.target.value.replace('%', '')) || 0;
    handleFormChange(percentage + '%', "discountPercentage", index);
  }}
  onFocus={(e) => {
    handleFormChange(row.discountPercentage.replace('%', ''), "discountPercentage", index);
  }}
  style={{}}
/>
              </td>
              <td style={{ }}>
                <input
                  type="text"
                  className="form-control"
                  value={row.discount}
                  onChange={(e) => handleFormChange(e.target.value, "discount", index)}
                 
                  style={{ textAlign: "right", border: "none", }}
                />
              </td>
              <td style={{  }}>
              <div style={{width: 150}}>
            {/* <Form.Select
  name="tax" 
  className="form-control" 
  required 
  value={row.vat} 
  onChange={(e) => handleFormChange(e.target.value, "vat", index)} 
  style={{width: "100px"}}
>
  <option value="">Select</option>
  {taxes.map((item) => (
    <option key={item.id} value={item.id}>
      {item.short_name} - {item.rate}
    </option>
  ))}
</Form.Select> */}

                <Select
                value={row.vat}
                  onChange={(selectedOption) => handleFormChange(selectedOption, "vat", index)}
                  options={taxes}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    menu: (provided) => ({
                      ...provided,
                      maxHeight: '300px',
                      overflowY: 'auto',
                    }),
                  }}
                />
                </div>
              </td>
            
              <td style={{ width: '7rem' }}>
                <CurrencyInput
                  name={`rowLineTotal ${index}`}
                  decimalsLimit={2}
                  value={row.amount}
                  className="form-control"
                  disabled
                  style={{ textAlign: "right", border: "none", width: '8rem' }}
                />
              </td>
              <td style={{ textAlign: "center", width: "2rem" }}>
              <button style={{backgroundColor: "unset"}} className={classes.btntrash}  onClick={() => deleteRow(index)}>
                <img src={DeleteIcon}/>
                </button>
              {/* <div className="btn btn-danger-soft btn-sm" onClick={() => deleteRow(index)}>
                <i className="far fa-trash-alt"  style={{color: "#dc3545", backgroundColor: "#dc35451a", padding: 2, borderColor: "#dc35454d", borderRadius: 5, fontSize: 12}}></i>
                </div> */}
              </td>
            </tr>
          ))}

        </tbody>
      </table>
      </div>

          <Form.Group>
          <div style={{ marginTop: 30, marginBottom: 20, display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }} >
            <div className="col-md-6" style={{ marginLeft: '10px' }}>
              <Form.Group className="mb-3">
                <div className="d-flex align-items-center form-group-custom">
                  <Form.Label style={{marginRight: "10px"}}>Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    // value={description}
                    // onChange={(e) => setDescription(e.target.value)}
                    name="description"
                    // style={{ width: "1000px" }}
                  />

                </div>
              </Form.Group>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 10, justifyContent: 'flex-end' }}>
              <div style={{ display: "flex", justifyContent: "flex-end", alignItems: 'center', gap: '5px' }}>
                <label for="example-text-input" style={{ textAlign: 'right' }}>Total V.A.T:</label>
                <div style={{ padding: '0', width: '10rem', }}>

                  
                  <CurrencyInput
                    name='total-amount'
                    decimalsLimit={2}
                    value={totalTax}
                    className="form-control"
                    disabled
                    style={{ textAlign: "right", border: "none", width: '10rem' }}
                  />

                </div>
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end", alignItems: 'center', gap: '5px' }}>
                <label for="example-text-input" >Total Discount:</label>
                <div style={{ padding: '0' }}>
                  <CurrencyInput
                    name='total-amount'
                    decimalsLimit={2}
                    value={totalDiscount}
                    className="form-control"
                    disabled
                    style={{ textAlign: "right", border: "none", width: '10rem' }}
                  />

                </div>
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end", gap: '5px', alignItems: 'center', }}>
                <label for="example-text-input" >Total Amount:</label>
                <div style={{ padding: '0' }}>
                  <CurrencyInput
                    name='total-amount'
                    decimalsLimit={2}
                    value={totalAmount}
                    className="form-control"
                    disabled
                    style={{ textAlign: "right", border: "none", width: '10rem' }}
                  />

                </div>
              </div>
            </div>
          </div>
         
          </Form.Group>

    </Container>
      </Form.Group>
 
    </Form>
  </Modal.Body>
  <Modal.Footer style={{marginRight: "14px"}}>
    <Button variant="danger" onClick={handleClose1}>
      Go back
    </Button>
    <Button className={classes.customButton} onClick={createSalesInvoice}>
      Save Changes
    </Button>

  </Modal.Footer>
</Modal>

<Modal show={uploadShow} onHide={handleUploadClose} animation={false}>
              <Modal.Header closeButton>
                <Modal.Title>Upload Purchase Invoice</Modal.Title>
              </Modal.Header>    
              <Modal.Body style={{padding: 0}}>
                          <Form.Group style={{padding: 10}}>
                        
                        </Form.Group>
                        {/* <hr className={classes.downline} /> */}
                          
                          <Form style={{padding: 10}}>
                          <div style={{ marginTop: 10 }} />
                          <Form.Label>Invoice Code:</Form.Label>
                      <Form.Control
                        className={classes.formControl}
                        type="text"
                        
                        value={sICode}
                      
                        disabled
                      />
                                      
                                      <div style={{ marginTop: 10 }} />
                                      <Form.Label>Transaction Date:</Form.Label>
                                      <Form.Control
                                        type="date"
                                        onChange={handleDateChange}
                                        value={selectedDate}
                                      />
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                      
                              <Form.Label style={{ marginTop: 10 }}>Description</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Enter Description"
                                autoFocus
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                              />
                              <Form.Label style={{ marginTop: 10 }}>Debit GL</Form.Label>
                              <Select
                              // loading={isLoading}
                              options={accPay}
                              placeholder='Select Debit Account'
                              onChange={setSelectedPayables}
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                menu: (provided) => ({
                                  ...provided,
                                  maxHeight: '300px',
                                  maxWidth: '700px',
                                  overflowY: 'auto',
                                }),
                              }}
                            />
                              
                              <div style={{ marginTop: 10 }} />
                                      <Form.Label>File</Form.Label>
                                      <Form.Control
                                        type="file"
                                        placeholder="Choose file"
                                        accept=".xlsx"
                                        onChange={handleImageChange}
                                      />
                            </Form.Group>
                          </Form>
                        </Modal.Body>

              <Modal.Footer>
                <Button variant="danger" onClick={handleUploadClose}>
                  Go back
                </Button>
                <Button className={classes.customButton}  onClick={uploadStatement}>
                  Make Payment
                </Button>
              
              </Modal.Footer>
            </Modal>
            {uploadLoading && (
                <div className={classes.overlay}>
                  <img src={RotatingLogo} alt="Loading..." className={classes.rotatingLogo} />
                </div>
                )}

            <Modal show={show} onHide={handleClose} size="lg" animation={false}>
          <Modal.Header closeButton>
            <Modal.Title>Create Purchases Invoice</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form style={{ marginTop: 20 }}>
              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Row>
                <Col md={6}>
                <Form.Label className={classes.formLabelCustom}>Invoice To</Form.Label>             
                <Select
                  // loading={loading}
                  options={extendedCustomerList}
                  placeholder='Select Supplier'
                  onChange={handleCustomerChange}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    menu: (provided) => ({
                      ...provided,
                      maxHeight: '300px',
                      maxWidth: '700px',
                      overflowY: 'auto',
                    }),
                  }}
                />
                </Col>


                <Col md={6}>
                <Form.Label >Invoice Code</Form.Label>
                      <Form.Control
                        className={classes.formControl}
                        type="text"
                        value={sICode}
                        disabled
                      />
                </Col>
              </Row>
              <Row className="mb-2 mt-4">
                <Col md={6}>
                <Form.Label >Description</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={1}
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        name="description"
                      />
                </Col>

                <Col md={6}>
                <Form.Label >Transaction Date</Form.Label>
                      <Form.Control
                              type="date"
                              // value={selectedDate}
                              // onChange={handleDateChange}
                              // min={minDate}
                              // max={maxDate} it was set in readdata using local storage
                            />

                </Col>
              </Row>
              <Row className="mb-3 mt-4">
                <Col md={6}>
                <Form.Label>Debit GL</Form.Label>
                  <Select
                    // loading={isLoading}
                    options={accPay}
                    placeholder='Select Debit Account'
                    onChange={setSelectedPayables}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      menu: (provided) => ({
                        ...provided,
                        maxHeight: '300px',
                        maxWidth: '700px',
                        overflowY: 'auto',
                      }),
                    }}
                  />
                    
                </Col>
              </Row>
              </Form.Group>
                    <Form.Group>
                      <h5 style={{marginBottom: 20, marginTop: 15}}>Add Account(s)</h5>

                      <div className="table-responsive">
      <table className={classes.customtable}>
        <thead>
          <tr>
            <th>Account </th>
            <th>Account Code</th>
            <th>Description</th>
            <th>Amount(N)</th>
            <th>V.A.T</th>
            <th>Total Amount</th>
            <th style={{backgroundColor: "unset"}} className="text-center">
              <button style={{backgroundColor: "unset"}} className={classes.plusbtn} onClick={addRows}>
              <FaPlus
              size={12}
              color="white"
              style={{ cursor: "pointer" }}
            />
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          {rows1.map((row, index) => (
            <tr key={index}>
              <td>
                <Form.Control
                  type="text"
                  value={rows1.account}
                  onChange={(e) =>
                    handleChange1(index, "account", e.target.value)
                  }
                />
              </td>
              <td>
                <Form.Control
                  type="text"
                  value={rows1.accCode}
                  onChange={(e) =>
                    handleChange1(index, "accCode", e.target.value)
                  }
                />
              </td>
              <td>
                <Form.Control
                  type="text"
                  value={rows1.description}
                  onChange={(e) =>
                    handleChange1(index, "description", e.target.value)
                  }
                />
              </td>
              <td>
                <Form.Control
                  type="text"
                  value={rows1.amount}
                  onChange={(e) =>
                    handleChange1(index, "amount", e.target.value)
                  }
                  style={{textAlign: "right"}}
                />
              </td>
              <td>
                <Form.Control
                  type="text"
                  value={rows1.vat}
                  onChange={(e) =>
                    handleChange1(index, "vat", e.target.value)
                  }
                />
              </td>
              <td>
                <Form.Control
                  type="text"
                  value={rows1.total}
                  onChange={(e) =>
                    handleChange1(index, "total", e.target.value)
                  }
                  style={{textAlign: "right"}}
                />
              </td>
              <td className="text-center">
                <button style={{backgroundColor: "unset"}} className={classes.btntrash} onClick={() => deleteRows(index)}>
                <img src={DeleteIcon}/>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
                    </Form.Group>

            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={handleClose}>
              Go back
            </Button>
            <Button className={classes.customButton} onClick={createBeneficiary}>
              Create Invoice
            </Button>
          </Modal.Footer>
        </Modal>
        {loading1 && (
                <div className={classes.overlay}>
                  <img src={RotatingLogo} alt="Loading..." className={classes.rotatingLogo} />
                </div>
                )}


        <div className={classes.topContainer}>
          <div className={classes.topNavBars}>
            <Button className={classes.buttonsNav}>Remitances</Button>
            <Button className={classes.buttonsNav}>Petty Cash</Button>
            <Button className={classes.buttonsNav}>Supplier's Payment</Button>
            <Button className={classes.buttonsNav}>Customer's Leger</Button>
          </div>
          <div style={{}}/>
            <h3 className={classes.topText}>Purchase Invoice</h3>
            <p className={classes.prgText}>Create, View, Edit, Delete, and Print Purchase Invoice</p>
            <div className={classes.cards}>
            <div className={classes.cardOne}>
                <p className={classes.cardText}>Total Payables</p>
                <p className={classes.cardNumber}>{statLoading ? <Skeleton width={80} height={20} /> : stat?.total_number_of_purchase_invoice}</p>
                </div>

                <div className={classes.cardTwo}>
                <p className={classes.cardText1}>Total Paid Invoices</p>
                <p className={classes.cardNumber1}> {statLoading ? <Skeleton width={120} height={20} /> : parseFloat(stat.total_purchase_invoice_amount).toLocaleString('en-US', {
          minimumIntegerDigits: 1,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })}
                </p>
                </div>

            </div>

            <div className={classes.subContainer}>
             
                            {/* <div className={classes.statCount}>
                              <div className={classes.statConn}>
                              <p className={classes.txtHd}>Total Payables</p>
                              <p className={classes.txtHds}>9</p>
                              </div>
                            </div> */}
                            <div className={classes.btnlays} style={{display: "flex", gap: "20px"}}>
                            <button className={classes.loanBtn} 
            // onClick={handleShow}
            onClick={handleShow}
            >
              <img src={plus} alt="plus" /> 
              Create Purchase Invoice
            </button>

                            <button className={classes.loanBtn} 
            onClick={handleUploadShow}
            >
              Upload Invoice
            </button>

            <button  className={classes.customButton1} >
                          <a 
                          href={`https://account-api.patna.ng/api/v1/download-purchase-invoice?province_id=${provinceID}`} 
                          download>
                          <img src={download} alt="download" /> Download Template
                          </a>
                        </button>

         
           
          </div>

          <div className={classes.searchInputWrapper}>
                                <input
                                    type="text"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className={classes.searchInput}
                                    placeholder="Search accounts..."
                                />
                                <Search className={classes.searchIcon} size={16} />
                            </div>
            </div>
            <div className={classes.tableContainer}>
          <table className={classes.tableTable}>
  <thead className={classes.tableHeader}>
                             <tr>
                              {/* <th>S/N</th> */}
                              <th>#</th>
                              <th>Invoice Number</th>
                              <th >Description</th>
                              <th >Supplier</th>
                              <th style={{textAlign: "right"}}>Amount</th>
                              <th> <span style={{marginLeft: "10px"}}>Action</span> </th>
                            </tr>
  </thead>
  <tbody>

  {roleLoading ? (
  searchTerm ? (
    <tr>
      <td colSpan={5} style={{ textAlign: "center" }}>
        Fetching Suppliers...
      </td>
    </tr>
  ) : (
    Array(5)
      .fill()
      .map((_, idx) => (
        <tr key={idx}>
          {Array(6)
            .fill()
            .map((_, i) => (
              <td key={i}>
                <Skeleton height={20} style={{ marginBottom: 10 }} />
              </td>
            ))}
        </tr>
      ))
  )
) : displayedData.length > 0 ? (
  displayedData.map((item, index) => (
    <tr key={index}>
      <td className={classes.textby}>{index + 1}</td>
      <td className={classes.textby}>{item.invoice_number}</td>
      <td className={classes.textby}>
        <span
          className={classes.statucColor}
          style={getLoanColors(item.description)}
        >
          {item.description}
        </span>
      </td>
      <td>{item.supplier?.name}</td>
      <td style={{ textAlign: "right" }}>
        {parseFloat(item.amount).toLocaleString("en-US", {
          minimumIntegerDigits: 1,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </td>
      <td>
        <div className={classes.btnAction}>
          <button
            style={{
              backgroundColor: "transparent",
              border: 0,
              cursor: "pointer",
            }}
            onClick={() => handleShow1(item)} // add item.id
          >
            <img src={EyeIcon} />
          </button>

          {/* <button
            style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}
            onClick={() => handleShow1(loan)} 
          >
            <img src={PencilIcon}/>
          </button> */}

          <button style={{ border: "none" }}>
            <FaPrint
              style={{
                color: "rgb(23, 162, 184)",
                backgroundColor: "rgb(175, 225, 233)",
                padding: "2px",
                border: "1px solid rgb(176, 209, 214)",
                borderRadius: "5px",
                fontSize: "20px",
              }}
            />
          </button>

          <button
            style={{
              backgroundColor: "transparent",
              border: 0,
              cursor: "pointer",
            }}
            onClick={() => handleTrashClick(item.id)}
          >
            <img src={DeleteIcon} />
          </button>
        </div>
      </td>
    </tr>
  ))
) : null}
  </tbody>

  {!roleLoading && searchTerm && displayedData.length === 0 && (
  <tbody>
    <tr>
      <td colSpan={5} style={{ textAlign: "center" }}>
        No Invoices found
      </td>
    </tr>
  </tbody>
)}
</table>

{!roleLoading && (
            <div className={classes.paginationStyle}>
              <div className={classes.footerSubOne}>
                <button onClick={handlePrevPage}
                  disabled={currentPage === 1} className={classes.btnFirst}>Prev</button>
                {[...Array(totalPages)].map((_, page) => {
                  // Show only 5 pages or less if available
                  if (page < 5 || page === currentPage - 1 || page === totalPages - 1) {
                    return (
                      <span key={page + 1} className={classes.ftOne}>
                        <button
                          className={`${classes.pageNumber} ${currentPage === page + 1 ? classes.active : ""}`}
                          onClick={() => setCurrentPage(page + 1)}
                        >
                          {page + 1}
                        </button>
                      </span>
                    );
                  }
                })}


                <button className={classes.btnSec} onClick={handleNextPage}
                  disabled={currentPage === totalPages}>Next</button>
              </div>
              <p className={classes.displayPag}>Displaying {`Page ${currentPage} - ${totalPages} pages`} of {formattedTotalEntries} entries</p>
            </div>
          )}



            </div>
        </div>
    </div>
  )
}

export default PurchaseInvoices